import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { Teacher } from '@app/models/users'

import { AbilityContext } from '@app/context/ability-context'
import { defineTeacherAbilities, authorize } from '@app/ability'

class TeacherLayout extends Component {
  render() {
    const Component = this.props.component
    const { teacher, route, global } = this.props
    const ability = defineTeacherAbilities(teacher, global)

    if (!authorize(ability, Component)) {
      return <Redirect to={`/404`} />
    }

    return (
      <div className="layout layout--public layout--forced-landscape" >
        <Helmet>
          <title>{I18n.t('layouts.teacher.title')}</title>
          <meta name="viewport" content="width=device-width, user-scalable=no, initial-scale=1, maximum-scale=1" />
        </Helmet>

        <AbilityContext.Provider value={ability}>
          <Component teacher={teacher} route={route} global={global} />
        </AbilityContext.Provider>
      </div>
    )
  }
}

TeacherLayout.propTypes = {
  teacher: PropTypes.instanceOf(Teacher).isRequired,
  global: PropTypes.object.isRequired
}

export default TeacherLayout
